// import external dependencies
import 'jquery';

///////slick js
import 'slick-carousel/slick/slick.min';

import 'slick-lightbox/dist/slick-lightbox.min';
// Import everything from autoload
import './autoload/_bootstrap.js'

import './multiselect';
// import local dependencies
import Router from './util/Router';
import common from './routes/common';
import home from './routes/home';
import aboutUs from './routes/about';
import pageTcmAuthenticatorHomepageData from './routes/contactformsTcm';

/** Populate Router instance with DOM routes */
const routes = new Router({
  // All pages
  common,
  // Home page
  home,
  // About Us page, note the change from about-us to aboutUs.
  aboutUs,

  pageTcmAuthenticatorHomepageData,
});

// Load Events
jQuery(document).ready(() => routes.loadEvents());

$(function() {
  $('.post_types').multiselect({
    includeSelectAllOption: true,               
    buttonClass: 'btn btn-warning btn-multiselect position-relative',
    selectAllName: false,
    nonSelectedText: 'Filter',
  }).multiselect('selectAll', false);
  
});




// WEBPACK FOOTER //
// ./scripts/main.js